import React, { useEffect, useState } from "react";
import {Container} from "react-bootstrap";
import "./LoginPage.css";
import {
  BG_URL,
  LOGO_URL,
  navigatePage,
  ORG_ID,
  ORG_INFO,
  PRIMARY_COLOR,
  ROUTE_PREFIX,
  SECONDARY_COLOR,
  setInitialPageInStorage,
  setLoginValueInStorage,
  TABLE_ID,
} from "../config";
import {
  getOrganisationFromSlug,
  getRestaurantConfig,
} from "../api/ApiServices";
import { withRouter } from "react-router-dom";
import ScanInfoError from "../components/end-customer/ScanInfoError";
import InitialLoading from "../components/InitialLoading";

const InitialPage = ({ match, location }) => {
  const { restaurantName } = match.params || {};
  const params = new URLSearchParams(location.search);
  const tableId = params.get(TABLE_ID);
  const [isValidURL, setIsValidURL] = useState(true);
  // Loading states
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isOrganisationLoading, setIsOrganisationLoading] = useState(false);
  const [isConfigLoading, setIsConfigLoading] = useState(false);

  const getOrganisationInfo = async () => {
    localStorage.clear();
    console.log("getOrganisationInfo function called!");
    setIsOrganisationLoading(true);
    getOrganisationFromSlug(restaurantName)
      .then(async (res) => {
        const parsedData = await res.json();
        console.log("response of organisation get api", parsedData);
        if (res.status === 200) {
          if (parsedData) {
            const orgData = parsedData.data;
            const orgId = parsedData._id;
            if (orgData) {
              localStorage.setItem(ORG_ID, orgId);
              localStorage.setItem(ORG_INFO, JSON.stringify(orgData));
              if (tableId && tableId.length > 0) {
                setIsValidURL(true);
                getConfig();
              } else {
                setIsValidURL(false);
              }
            }
          }
        } else {
          setIsValidURL(false);
          setIsInitialLoading(false);
        }
        setIsOrganisationLoading(false);
      })
      .catch((err) => {
        console.log('catch block error :', err)
        setIsValidURL(false);
        setIsInitialLoading(false);
        setIsOrganisationLoading(false);
      });
  };

  const getConfig = () => {
    const orgId = localStorage.getItem(ORG_ID);
    console.log("orgId", orgId);
    setIsConfigLoading(true);
    getRestaurantConfig(orgId)
      .then(async (res) => {
        const parsedData = await res.json();
        console.log("response of restaurant config", parsedData);
        if (res.status === 200) {
          const data = parsedData.data;
          if (data) {
            const logoImg = data.logo;
            const bgImg = data.bgImage;
            const primaryColor = data.primaryColor;
            const secondaryColor = data.secondaryColor;
            const initialPage = data.initialPage;
            localStorage.setItem(LOGO_URL, logoImg);
            localStorage.setItem(BG_URL, bgImg);
            localStorage.setItem(PRIMARY_COLOR, primaryColor);
            localStorage.setItem(SECONDARY_COLOR, secondaryColor);
            setLoginValueInStorage(data.login);
            setInitialPageInStorage(initialPage);
            localStorage.setItem(SECONDARY_COLOR, secondaryColor);
            localStorage.setItem(TABLE_ID, tableId)
            document.documentElement.style.setProperty(
              "--primary-color",
              primaryColor
            );
            document.documentElement.style.setProperty(
              "--secondary-color",
              secondaryColor
            );
            if (initialPage && initialPage.length > 0) {
              navigatePage(`/${ROUTE_PREFIX}${restaurantName}/${initialPage}`);
            }
            setIsConfigLoading(false);
            setIsInitialLoading(false);
          } else {
            setIsConfigLoading(false);
            setIsInitialLoading(false);
          }
        } else {
          setIsValidURL(false);
          setIsConfigLoading(false);
          setIsInitialLoading(false);
        }
      })
      .catch((err) => {
        console.log('catch block error :', err)
        setIsValidURL(false);
        setIsConfigLoading(false);
        setIsInitialLoading(false);
      });
  };

  useEffect(() => {
    getOrganisationInfo();
  }, []);

  return (
    <>
      {isInitialLoading ? (
        <InitialLoading isConfigLoading={isConfigLoading} isOrganisationLoading={isOrganisationLoading}/>
      ) : isValidURL ? (
        <Container fluid className="login-page-container">
          Home
        </Container>
      ) : (
        <ScanInfoError />
      )}
    </>
  );
};

export default withRouter(InitialPage);